import util from "./util";

var unbind = 0;
var unbindcarousel = 0;
var unbindreccarousel = 0;

function getPageCategory() {
	//return window.pageContext.title || "Content"; ###### this throws product name
	switch (window.Resources.PAGE_CATEGORY) {
	case 'product-showincategory':
		return "Product Page";
		break;
	case 'product-show':
		return "Product Page";
		break;
	case 'search-show':
		return "Category Page";
		break;
	case 'home-show':
		return "Home Page"
		break;
	case 'cart-show':
		return "Cart Page"
		break;
	case 'cart-addtowishlist':
		return "Cart Page"
		break;
	case 'customerservice-contactus':
		return "Contact Customer Care"
		break;
	case 'customerservice-concierge':
		return "Ask An Expert"
		break;
	case 'account-startregister':
		return "Account Creation"
		break;
	case 'account-editprofile':
		return "My Account"
		break;
	case 'address-list':
		return "My Account"
		break;
	case 'paymentinstruments-list':
		return "My Account"
		break;
	case 'wishlist-show':
		return "My Account"
		break;
	case 'order-history':
		return "My Account"
		break;
	case 'orderreplenishment-show':
		return "My Account"
		break;
	case 'login-show':
		return "Account Registration"
		break;
	case 'coshipping-start':
		return "Checkout"
		break;
	case 'coshipping-singleshipping':
		return "Checkout"
		break;
	case 'cobilling-start':
		return "Checkout"
		break;
	case 'cobilling-billing':
		return "Checkout"
		break;
	case 'search-showcontent':
		return "Site Search"
		break;
	case 'cocustomer-loginform':
		return "Customer Login";
		break;
	case 'default-start':
		return "Home Page";
		break;
	case 'search-brandify':
		return "Store Locator Page";
		break;
	default:
		return "Content";
		break;
	}
}
// Specific for checkout and cart page only
function couponsubcategory() {
	switch (window.Resources.PAGE_CATEGORY) {
	case 'cart-show':
		return "Cart"
		break;
	case 'coshipping-start':
		return "Shipping"
		break;
	case 'coshipping-singleshipping':
		return "Payment"
		break;
	case 'cobilling-start':
		return "Payment"
		break;
	case 'cobilling-removegiftcertificate':
		return "Payment"
		break;
	case 'cobilling-billing':
		return "Review"
		break;
	case 'account-editprofile':
		return "Profile"
		break;
	case 'address-list':
		return "Addresses"
		break;
	case 'paymentinstruments-list':
		return "Payment Methods"
		break;
	case 'wishlist-show':
		return "Saved For Later"
		break;
	case 'order-history':
		return "Order History"
		break;
	case 'orderreplenishment-show':
		return "Replenishment"
		break;
	default:
		break;
	}
}

function isMobile() {
	return $(window).width() <= 640;
}
//Specific for PDP
function getProductName() {
	return $(".product-detail .product-name").text();
}
//Specific for PDP
function getProductBrand() {
	return SitePreferences.PRODUCT_BRAND; //$(".product-detail .product-brand").text();
}
//Specific for PDP
function getProductID() {
	return $("#pid").val();
}
//Specific for PDP
function getProductCategory() {
	return $(".breadcrumb").find(".breadcrumb-element:eq(2)").text().trim();
}
//Specific for PDP
function getProductsubCategory() {
	return $(".breadcrumb").find(".breadcrumb-element:eq(3)").text().trim();
}
// Specific for PDP
function getProductsubsubCategory() {
	return $(".breadcrumb").find(".breadcrumb-element:eq(4)").text().trim();
}
// Specific for PDP
function getProductOrederType() {
	var replen = $(".replenishmentCycle").val();
	if (replen > 0) {
		return "Replenishment"
	} else {
		return "Regular"
	}

}

function getPageSubcategory() {
	return window.pageContext.title || "Content";
}

function getLanguage() {
	if (window.User.locale.indexOf("en") >= 0) {
		return "English";
	} else if (window.User.locale.indexOf("cn") >= 0) {
		return "Chinese";
	} else if (window.User.locale.indexOf("es") >= 0) {
		return "Spanish";
	} else {
		return window.User.locale;
	}
}

// page-specific: Cart, Checkout
function getPageError() {
	var $errorMsg = $(".error-form");
	if ($errorMsg.length === 0) {
		return "";
	}

	return $errorMsg.html().trim();
}

function getActiveSortingRule() {
	var httpParams = util.getQueryStringParams(window.location.href);
	var sortParam = httpParams["srule"];

	if (!sortParam) {
		return null;
	}

	return sortParam.split("-").map(function (w) {
		return w[0].toUpperCase() + w.substr(1);
	}).join(" ");
}

function pushToDataLayer(o) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(util.filterObj(o));
}

function isScrolledIntoView(elem) {
	var docViewTop = $(window).scrollTop();
	var docViewBottom = docViewTop + $(window).height() - 150;
	var elemTop = $(elem).offset().top;
	var result = [];
	result.push(((elemTop <= docViewBottom) && (elemTop >= docViewTop)));
	if ((elemTop <= docViewBottom) && (elemTop >= docViewTop)) {
		result.push($(elem).parent().attr('class'));
	}
	return result;
}

function getpage() {
	var url = window.location.href;
	var splittedurl = url.split("?");
	var page = splittedurl[0].split("/");
	return page[page.length - 1]
}
//page-specific: PLP
function getRefinementsFromURL() {
	var str = "";
	if (window.location.href.split("?").length > 1) {
		var urlparam;
		if (window.location.href.split("?")[1].indexOf("&") > -1) {
			urlparam = window.location.href.split("?")[1].split("&");
			var length = urlparam.length;
			var prefnval, prefnkey, prefvval, prefvkey;
			for (var i = 0; i < length; i++) {
				var prefn = urlparam[i].indexOf("prefn");
				if (prefn > -1) {
					prefnkey = urlparam[i].split("=")[0];
					prefnval = urlparam[i].split("=")[1];
					var num = prefnkey.charAt(5);
					for (var a = 0; a < length; a++) {
						var prefv = urlparam[a].indexOf("prefv");
						prefvkey = urlparam[a].split("=")[0];
						if (prefvkey == "prefv" + num) {
							prefvval = urlparam[a].split("=")[1];
							str += "[" + prefnval + ":" + prefvval + "]";
						}
					}
				}
			}
		}
	}
	return str;
}

function trackConsultationEvent(data) {
	var TOOL_TYPES = {
		"skincareConsultation": "Skincare Consultation"
	};

	pushToDataLayer({
		"event": data.event,
		"pageCategory": "Consultation Tool",
		"consultationToolType": TOOL_TYPES[data.toolname] || data.toolname,
		"consultationQuestion": data.question,
		"consultationResponse": data.answers
	});
}

function trackConsultationPageview(data) {
	pushToDataLayer({
		"event": "consultationSteps",
		"pageCategory": "Consultation Tool",
		"consultationToolType": data.toolname,
		"consultationStep": data.pagename
	});
}

function trackInternalPromotionEvent(data) {

	var promotionURL = data.pageName;

	pushToDataLayer({
		"event": "eePromoClick",
		"pageSubCategory": data.pageSubCategory,
		"pageCategory": data.pageCategory,
		'promotions': [{
			"position": data.position,
			"id": data.id,
			"creative": data.creative,
			"name": data.name
		}]
	}), (function () {
		setTimeout(function () {
			if (promotionURL != undefined) {
				document.location = promotionURL;
			}
		}, 1000);
	})();
}

function trackInternalPromotionPageView(data) {
	pushToDataLayer({
		"eeAction": "eePromoView",
		"event": "eePromoView",
		"pageSubCategory": data.pageSubCategory,
		"pageCategory": data.pageCategory,
		'promotions': [{
			"position": data.position,
			"id": data.id,
			"creative": data.creative,
			"name": data.name
		}]
	});
}

/*
 * datalayer for filter panel (PLP - Mobile view)
 */
function filterPanelOpened() {
	pushToDataLayer({
		"event": "filterDisplayed"
	});
}
function filterPanelClosed() {
	pushToDataLayer({
		"event": "filterClosed"
	});
}

/*
 * datalayer for minicart panel 
 */
function minicartPanelOpened() {
	pushToDataLayer({
		"event": "popinBagOpen"
	});
}

function cartModalOpen() {
	pushToDataLayer({
		"event": "cartModalOpen"
	});
}

function cartModalClose() {
	pushToDataLayer({
		"event": "cartModalClose"
	});
}

function minicartPanelClosed() {
	pushToDataLayer({
		"event": "popinBagClosed"
	});
}
//Gift Card Added to Cart
function addBonusProductMinicartDataLayer(pids) {
	if(pids && pids.length > 0){
		let pidsArr = pids.split(',');
		let refProd =  miniBasketConfirmation.productLineItems;
		let finalProd = [];

		for (let i = 0; i < refProd.length; i++) {
			if( (pidsArr.includes(refProd[i].productVariantID) || pidsArr.includes(refProd[i].id)) && refProd[i].productType == 'Bonus Product'){
				finalProd.push(refProd[i]);
			}
		}

		pushToDataLayer({
			'event' : 'add_gwp_to_cart', 
			"addToCartType": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory,
			"pageCategory": pageInfo.pageCategory,
			"product" :finalProd
			});	


	}else{
		//Filter the bonus products based on product type
		let  lineItems = miniBasketConfirmation.productLineItems;

		let filteredBonus = lineItems.filter((lineItem) => {
			return lineItem.productType == "Bonus Product";
		});
		//Minicart bonus products gets added to the top of the queue hence index is 0
		let index = 0;

		pushToDataLayer({
			'event' : 'add_gwp_to_cart', 
			"addToCartType": pageInfo.pageCategory,
			"pageSubCategory": pageInfo.pageSubCategory,
			"pageCategory": pageInfo.pageCategory,
			"product" : {
				"id": filteredBonus[index].id,
				"category": filteredBonus[index].category,
				"name": filteredBonus[index].name,
				"brand": getProductBrand() && getProductBrand(),
				"price": filteredBonus[index].price ? filteredBonus[index].price : 0,
				"quantity": filteredBonus[index].quantity,
				"size":  filteredBonus[index].size && filteredBonus[index].size,
				"subCategory": filteredBonus[index].subCategory,
				"subSubCategory": filteredBonus[index].subSubCategory,
				"productAutoReplen": filteredBonus[index].productAutoReplen,
				"productOutOfStock": filteredBonus[index].productOutOfStock,
				"productColor": filteredBonus[index].productColor,
				"productType": filteredBonus[index].productType,
				"productOrderType": ($(this).parents(".cart-row").find(".replenishment .replenishmentDays").length > 0) ? "Replenishment" : "Regular",
				"productVariantID": filteredBonus[index].productVariantID,
				"collectionName": filteredBonus[index].collectionName,
				"productNumReviews": filteredBonus[index].productNumReviews && filteredBonus[index].productNumReviews,
				"productStarRating": filteredBonus[index].productStarRating && filteredBonus[index].productStarRating
			}		
		});	
	}
}
//Data layer for quickview close
function quickViewClose() {
	var _this = $(this);
	pushToDataLayer({
		"event": "close_quickview",
		"productName" : tileVariantData.name? tileVariantData.name : null,
		"productCategory" : tileVariantData.catid? tileVariantData.catid :pageInfo.pageSubCategory ,
		"productSubcategory" : tileVariantData.subcategory? tileVariantData.subcategory : null,
		"productBrand" : getProductBrand()? getProductBrand() : null,
		"productId" : tileVariantData.masterID,
		"pageCategory" : pageInfo.pageCategory,
		"pageSubCategory" : pageInfo.pageSubCategory,
		"productSubsubCategory" : tileVariantData.subsubcategory? tileVariantData.subsubcategory : null
	});
}
// Data Layer for quickview show description
function quickViewShowDescription() {
	pushToDataLayer({
		event : "click_full_description_quickview",
		"productName" : tileVariantData.name? tileVariantData.name : null,
		"productCategory" : tileVariantData.catid?tileVariantData.catid :pageInfo.pageSubCategory,
		"productSubcategory" : tileVariantData.subcategory? tileVariantData.subcategory : null,
		"productBrand" : getProductBrand()? getProductBrand() : null,
		"productId" : tileVariantData.masterID,
		"pageCategory" : pageInfo.pageCategory,
		"pageSubCategory":pageInfo.pageSubCategory,
		"productSubsubCategory" : tileVariantData.subsubcategory? tileVariantData.subsubcategory : null
	});
}
function quickviewCartAdd() {
	if (localStorage.getItem('quickview')) {	
	pushToDataLayer({
		"event": "addToCart",
		"currencyCode": window.Resources.CURRENCY,
		"addToCartType": 'quickview',
		"pageCategory": pageInfo.pageCategory,
		"pageSubCategory": pageInfo.pageSubCategory,
		'products': $('.cart_page').length > 0 ? basketConfirmation.productLineItems : miniBasketConfirmation.productLineItems
		});
		localStorage.removeItem('quickview');
	}
}
function minicartProductList() {
	//eeListView dataLayer for minicart open
	var productsList = [];
	var count = 1;
	for(var i = 0; i < miniBasketConfirmation.productLineItems.length; i++) {
		if (miniBasketConfirmation.productLineItems.length) {
			var productlistdata = {
				"listType": "Mini Cart",
				"listName": "Articles in cart",
				"position": count++,
				"id": miniBasketConfirmation.productLineItems[i].id,
				"category": miniBasketConfirmation.productLineItems[i].category,
				"price": miniBasketConfirmation.productLineItems[i].price,
				"name": miniBasketConfirmation.productLineItems[i].name,
				"brand": getProductBrand(),
				"size": miniBasketConfirmation.productLineItems[i].size,
				"subCategory": miniBasketConfirmation.productLineItems[i].subCategory,
				"subSubCategory": miniBasketConfirmation.productLineItems[i].subSubCategory,
				"productAutoReplen": miniBasketConfirmation.productLineItems[i].productautoreplenish,
				"productOutOfStock": miniBasketConfirmation.productLineItems[i].productOutOfStock,
				"productColor": miniBasketConfirmation.productLineItems.productColor,
				"productType": miniBasketConfirmation.productLineItems[i].productType,
				"productVariantID": miniBasketConfirmation.productLineItems[i].productVariantID,
				"collectionName": miniBasketConfirmation.productLineItems[i].customBrand,
				"productNumReviews": miniBasketConfirmation.productLineItems[i].productNumReviews,
				"productStarRating": miniBasketConfirmation.productLineItems[i].productStarRating
			}
			productsList.push(productlistdata)
		}
		
	}
	pushToDataLayer({
		"currencyCode": window.Resources.CURRENCY,
		"event": "eeListView",
		"eeAction": "eeListView",
		"pageCategory": pageInfo.pageCategory,
		"pageSubCategory": pageInfo.pageSubCategory,
		'products': productsList
	})
	if (!$('html').hasClass('modal-open')) {
		$('html').addClass('modal-open');	
	}
};

function initializeGlobalEvents() {
	var navctr = true;
	var gtmNavData = "";

	$(document)

		// add to wishlist in pdp and quickview
		.on('click', ".wishlist-icon", function (e) {
			var _this = $(this);
			var _event = "clickSaveForLater";
			if (_this.hasClass("wishlist-added")) {
				_event = "removeFromWishlist";
			}
			if (_this.parents(".cart-row").length > 0) {
				var index = _this.parents(".cart-row").index();
				pushToDataLayer({
					"event": _event,
					"productCategory": basketConfirmation.productLineItems[index].category,
					"productSubCategory": basketConfirmation.productLineItems[index].subCategory,
					"productName": basketConfirmation.productLineItems[index].name,
					"pageCategory": getPageCategory(),
					"productId": basketConfirmation.productLineItems[index].id
				});
			} else {
				pushToDataLayer({
					"event": _event,
					"productCategory": getProductCategory(),
					"productSubCategory": getProductsubCategory(),
					"productName": _this.attr('data-element-name'),
					"pageCategory": getPageCategory(),
					"productId": _this.attr('data-element-pid')
				});
			}
		})

		// newsletter in navigation;
		.on("clicknewsletter", function (e, data) {
			pushToDataLayer({
				"event": "newsletterSubscription",
				"siteLocation": data.siteloc,
				"pageSubCategory": getPageCategory() == "My Account" ? getProductsubCategory() : "",
				"pageCategory": getPageCategory()
			});
		})


		// click ask question in pdp
		.on("click", ".bv-ask-question", function (e) {
			pushToDataLayer({
				page: getpage(),
				"event": "askQuestion",
				productCategory: getProductCategory(),
				pageSubCategory: "Ask a Question",
				productName: getProductName(),
				pageCategory: "Product Page"
			});
		})
		// Click on Reviews in PDP
		.on("click", ".bv-inline-histogram-ratings-star-container", function () {
			pushToDataLayer({
				page: getpage(),
				event: "productReviewsView",
				productCategory: getProductCategory(),
				pageSubCategory: "Reviews",
				productName: getProductName(),
				pageCategory: "Product Page"
			});
		})

		// add to cart from PDP
		.on('click', '#pdpMain .add-to-cart', function (e) {

			if (getPageCategory() == "Cart Page") {
				if (sessionStorage.getItem("cartupdate")) {
					sessionStorage.setItem("productUpdate", "1");
				}
			} else {
				window.productCache = window.productCache || {};
				pushToDataLayer({
					"currencyCode": window.Resources.CURRENCY,
					"event": "addToCart",
					"productOrderType": getProductOrederType(),
					"addToCartType": "Product Page",
					"pageCategory": getPageCategory(),
					'products': [{
						"id": getProductID(),
						"productVariantID": pdpdata.master ? pdpdata.defalutvariant : pdpdata.ID,
						"category": window.productCache.catid,
						"price": $(".add-to-cart").data("price"),
						"name": getProductName(),
						"brand": getProductBrand(),
						"quantity": Number($(".quantity select").val()),
						"size": $("#pdp-swatches li.selected").text().trim(),
						"subCategory": window.productCache.subcategory,
						"subSubCategory": window.productCache.subsubcategory,
						"productAutoReplen": $(".add-to-cart").data("replenishable"),
						"productOutOfStock": $(".add-to-cart").data("instock"),
						"productColor": $("#va-color option:selected").text().split("/")[0].trim(),
						"productType": "Product",
						"collectionName": pdpdata.customBrand,
						"productNumReviews": pdpdata.productNumReviews,
						"productStarRating": pdpdata.productStarRating
					}]
				});
			}
		})

		// Submit ask a question
		.on('click', ".bv-submission-section button:contains('Post Question')", function (e) {
			pushToDataLayer({
				"page": getpage(),
				"event": "submitQuestion",
				"productCategory": getProductCategory(),
				"question": $("#bv-textarea-field-questionsummary").val(),
				"productName": getProductName(),
				"pageSubCategory": "Ask a Question",
				"pageCategory": getPageCategory()
			});
		})

		// remove from cart
		.on('click', ".user-action-remove .button-text[value='Remove']", function (e) {
			var index = $(this).parents(".cart-row").index();
			pushToDataLayer({
				"currencyCode": window.Resources.CURRENCY,
				"event": "removeFromCart",
				"productOrderType": ($(this).parents(".cart-row").find(".replenishment .replenishmentDays").length > 0) ? "Replenishment" : "Regular",
				"pageCategory": getPageCategory(),
				'products': [{
					"id": basketConfirmation.productLineItems[index].id,
					"category": basketConfirmation.productLineItems[index].category,
					"price": basketConfirmation.productLineItems[index].price,
					"name": basketConfirmation.productLineItems[index].name,
					"brand": getProductBrand(),
					"quantity": basketConfirmation.productLineItems[index].quantity,
					"size": basketConfirmation.productLineItems[index].size,
					"subCategory": basketConfirmation.productLineItems[index].subCategory,
					"subSubCategory": basketConfirmation.productLineItems[index].subSubCategory,
					"productAutoReplen": basketConfirmation.productLineItems[index].productAutoReplen,
					"productOutOfStock": basketConfirmation.productLineItems[index].productOutOfStock,
					"productColor": basketConfirmation.productLineItems[index].productColor,
					"productType": basketConfirmation.productLineItems[index].productType,
					"productOrderType": ($(this).parents(".cart-row").find(".replenishment .replenishmentDays").length > 0) ? "Replenishment" : "Regular",
					"productVariantID": miniBasketConfirmation.productLineItems[index].productVariantID,
					"collectionName": miniBasketConfirmation.productLineItems[index].collectionName
				}]

			})

		})

		// remove from minicart
		.on('click', ".mini-cart-details .remove-link", function (e) {
			var index = $(this).parents(".mini-cart-product").index();
			pushToDataLayer({
				"currencyCode": window.Resources.CURRENCY,
				"event": "removeFromCart",
				"pageCategory": getPageCategory(),
				'products': [{
					"id": miniBasketConfirmation.productLineItems[index].id,
					"category": miniBasketConfirmation.productLineItems[index].category,
					"price": miniBasketConfirmation.productLineItems[index].price,
					"name": miniBasketConfirmation.productLineItems[index].name,
					"brand": getProductBrand(),
					"quantity": miniBasketConfirmation.productLineItems[index].quantity,
					"size": miniBasketConfirmation.productLineItems[index].size,
					"subCategory": miniBasketConfirmation.productLineItems[index].subCategory,
					"subSubCategory": miniBasketConfirmation.productLineItems[index].subSubCategory,
					"productAutoReplen": miniBasketConfirmation.productLineItems[index].productAutoReplen,
					"productOutOfStock": miniBasketConfirmation.productLineItems[index].productOutOfStock,
					"productColor": miniBasketConfirmation.productLineItems[index].productColor,
					"productType": miniBasketConfirmation.productLineItems[index].productType,
					"productOrderType": ($(this).parents(".cart-row").find(".replenishment .replenishmentDays").length > 0) ? "Replenishment" : "Regular",
					"productVariantID": miniBasketConfirmation.productLineItems[index].productVariantID,
					"collectionName": miniBasketConfirmation.productLineItems[index].collectionName
				}]
			})

		})
		// click zoom in pdp
		.on('click', ".productthumbnail.selected", function (e) {
			if ($('.quickview-modal').length === 0 && $('.quick-shop-panel').length === 0) {
				pushToDataLayer({
					"event": "productInteraction",
					"productCategory": getProductCategory(),
					"productSubCategory": getProductsubCategory(),
					"productName": getProductName(),
					"pageCategory": getPageCategory(),
					"productId": getProductID(),
					"interactionType": "Zoom"
				})
			}
		})

		// click full ingredients in pdp
		.on('click', ".type-fullingredients_openBtn", function (e) {
			pushToDataLayer({
				"event": "productInteraction",
				"productCategory": getProductCategory(),
				"productSubCategory": getProductsubCategory(),
				"productName": getProductName(),
				"pageCategory": getPageCategory(),
				"productId": getProductID(),
				"interactionType": "View Full Product Ingredients"
			})
		})

		.on("click", ".cart-promo-approaching", function () {
			pushToDataLayer({
				"event": "eePromoClick",
				"pageSubCategory": "Internal marketing",
				"pageCategory": "Cart Page",
				'promotions': [{
					"position": "Cart",
					"id": $(".cart-promo-approaching").data("promoid"),
					"creative": "Cart-Banner",
					"name": $(".cart-promo-approaching").data("promoname")
				}]
			})
		})

		.on("click", ".cart-coupon-code #add-coupon", function () {
			localStorage.removeItem('couponvalidation');
		})

		// track share button on PDP
		.on("click", ".socialsharing .share-icon", function () {
			pushToDataLayer({
				"socialAction": "Share",
				"event": "socialShare",
				"siteLocation": "product page",
				"pageCategory": getPageCategory(),
				"pageSubCategory": getPageSubcategory(),
				"socialNetwork": $(this).data("share")
			})
		})

		// Track Follow button on Footer
		.on("click", ".social-links a", function () {
			pushToDataLayer({
				"socialAction": "Follow",
				"event": "socialFollow",
				"siteLocation": "footer",
				"pageCategory": getPageCategory(),
				"socialNetwork": $(this).data("follow")
			})
		})

		// Add to all to Cart
		.on("click", "#add-all-to-cart", function () {
			var $regimenbg = $(this).parents(".regimen-bg");
			var products = [];
			$regimenbg.find('.gtm-product-tile').each(function () {
				var product = {};
				var tileVariantData = $(this).data('value');
				product.ID = tileVariantData.masterID || tileVariantData.ID;
				product.productVariantID = tileVariantData.ID;
				product.category = tileVariantData.catid;
				product.price = tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice;
				product.name = tileVariantData.name;
				product.brand = tileVariantData.brand;
				product.quantity = tileVariantData.quantity;
				product.size = tileVariantData.size;
				product.subCategory = tileVariantData.subcategory;
				product.subSubCategory = tileVariantData.subsubcategory;
				product.productAutoReplen = tileVariantData.productautoreplenish;
				product.productOutOfStock = tileVariantData.productOutOfStock;
				product.productColor = tileVariantData.productColor;
				product.productType = "Product";
				product.collectionName = tileVariantData.customBrand;
				product.productNumReviews = tileVariantData.productNumReviews;
				product.productStarRating = tileVariantData.productStarRating;
				products.push(product);
			});
			pushToDataLayer({
				"currencyCode": window.Resources.CURRENCY,
				"event": "addToCart",
				"productOrderType": getProductOrederType(),
				"addToCartType": getPageCategory(),
				"pageSubCategory": getProductsubCategory(),
				"pageCategory": getPageCategory(),
				'products': products
			});
		})

		// click email hyper link in navigation
		.on('click', '.emailcsr-nav', function () {
			if (window.Resources.PAGE_CATEGORY == "page-show") {
				pushToDataLayer({
					"event": "contactRequest",
					"contactType": "Email",
					"siteLocation": "Header",
					//"pageSubCategory": couponsubcategory(),
					"pageCategory": getProductCategory()
				});

			} else {
				pushToDataLayer({
					"event": "contactRequest",
					"contactType": "Email",
					"siteLocation": "Header",
					"pageSubCategory": window.Resources.PAGE_CATEGORY == "cart-show" ? "" : couponsubcategory(),
					"pageCategory": getPageCategory()
				});
			}

		})
		// Click email link in the customer care
		.on("click", ".content-asset a:contains('customerservice@shiseidousa.com')", function () {
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Email",
				"siteLocation": window.Resources.PAGE_CATEGORY == "cart-show" ? "Right Nav" : "Body",
				//"pageSubCategory": couponsubcategory(),
				"pageCategory": window.Resources.PAGE_CATEGORY == "cart-show" ? getPageCategory() : getProductCategory()
			});
		})

		.on("gtmcontactus", function () {
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Contact Customer Care Submission",
				"siteLocation": "Body",
				"pageCategory": getPageCategory()
			});
		})
		.on("askanexpert", function () {
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Ask An Expert Submission",
				"siteLocation": "Body",
				"pageSubCategory": couponsubcategory(),
				"pageCategory": "Ask An Expert"
			});
		})

		.on("click", ".LPMcontainer", function () {
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Live Chat",
				"siteLocation": getPageCategory() == "Checkout" ? "Header" : "Body",
				"pageSubCategory": couponsubcategory(),
				"pageCategory": getPageCategory()
			});
		})

		.on("click", ".LPMimage", function () {
			var id = $(this).attr("id");
			var chk = id.charAt(id.length - 1)
			if (chk == 1) {
				pushToDataLayer({
					"event": "contactRequest",
					"contactType": "Live Chat",
					"siteLocation": "Pop-up",
					"pageSubCategory": couponsubcategory(),
					"pageCategory": getPageCategory()
				});
			}
		})

		.on("click", ".footer-container .products ul li:nth-child(4)", function () {
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Phone",
				"siteLocation": "Footer",
				"pageSubCategory": window.Resources.PAGE_CATEGORY == "cart-show" ? "" : couponsubcategory(),
				"pageCategory": getPageCategory()
			});
		})

		// click on recommendation
		.on("click", ".recommendation-item", function () {
			if (getPageCategory() == "Product Page") {
				sessionStorage.setItem('listType', "Recommended Product List");
				sessionStorage.setItem('listName', "Product Page");
			} else if (getPageCategory() == "Home Page") {
				sessionStorage.setItem('listType', "Recently Viewed List");
				sessionStorage.setItem('listName', "Home Page");
			}

		})


		.on("click", ".catalog-link", function (e) {
			if (navctr == true) {
				gtmNavData = $(this).text().trim();
				sessionStorage.setItem("navlink", gtmNavData);
				sessionStorage.setItem("menuloc", "topmenu");
				util.setCookie('navdata', gtmNavData, .20);
				navctr = false;
			}
		})

		.on("click", ".main-nav .has-sub-menu a", function (e) {
			if (navctr == true) {
				gtmNavData = $(this).text().trim();
				sessionStorage.setItem("navlink", gtmNavData);
				sessionStorage.setItem("menuloc", "topmenu");
				util.setCookie('navdata', gtmNavData, .20);
				navctr = false;
			}
		})

		.on("click", ".refinement-header", function (e) {
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink", gtmNavData);
			sessionStorage.setItem("menuloc", "leftmenu");
		})

		.on("click", ".refinement-link", function (e) {
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink", gtmNavData);
			sessionStorage.setItem("menuloc", "leftmenu");
		})

		.on("click", ".breadcrumb-element", function (e) {
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("breadcrumbs", gtmNavData);
			sessionStorage.setItem("menuloc", "leftmenu");
		})

		.on("change", ".cart-qty-select", function (e) {
			if (getPageCategory() == "Cart Page") {
				if ($(".edit-modal").length > 0) {
					sessionStorage.setItem("cartupdate", "1");
				} else {
					sessionStorage.setItem("productUpdate", "1");
				}

			}

		})

		.on("change", ".quantity-select", function (e) {
			if (window.Resources.PAGE_CATEGORY == "wishlist-show") {
				sessionStorage.setItem("productUpdate", "1");
			}
		})

		.on("click", ".account-left-nav li", function (e) {
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink", gtmNavData);
			sessionStorage.setItem("menuloc", "leftmenu");
		})

		// Remove uservalidation attribute for userlogin validation
		.on('click', ".user-links .log-out-link", function (e) {
			localStorage.removeItem('uservalidation');
		})

		.on("change", "#va-color", function () {
			if (getPageCategory() == "Cart Page") {
				sessionStorage.setItem("cartupdate", "1");
			}
		})

		.on("click", ".close-button", function () {
			if (getPageCategory() == "Cart Page") {
				sessionStorage.setItem("cartupdate", "");
			}
		})

		.on("click", "#save-for-later", function () {
			if (getPageCategory() == "Cart Page") {
				sessionStorage.setItem("cartupdate", "");
			}
		})

		.on("click", "#pdp-swatches .selectable", function () {
			if (getPageCategory() == "Cart Page") {
				if (!$(this).hasClass("selected")) {
					sessionStorage.setItem("cartupdate", "1");
				}
			}
		})

		.on("click", ".search-suggestion-wrapper .hit", function () {
			gtmNavData = $(this).text().trim();
			sessionStorage.setItem("navlink", gtmNavData.replace(/\s\s+/g, ' '));
			sessionStorage.setItem("menuloc", "site search pop-in");
		})

		.on("click", ".search-suggestion-wrapper .product-suggestion", function () {
			gtmNavData = $(this).text().trim();
			var rep = gtmNavData.replace(/\n/g, " ");
			sessionStorage.setItem("navlink", rep.replace(/ +/g, " "));
			sessionStorage.setItem("menuloc", "site search pop-in");
		})

		// PLP click in list image
		.on("click", "#search-result-items .gtmindex .thumb-link", function () {
			var index = $(this).parents(".gtmindex").index(".gtmindex");
			if (index >= 0) {
				if (productData.page >= 1) {
					pushToDataLayer({
						"event": "eeListClick",
						"pageSubCategory": "",
						"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
						"filterChoice": getActiveSortingRule(),
						"dropDown": getRefinementsFromURL(),
						'products': [prodholder[index]]
					})
					sessionStorage.setItem('listType', prodholder[index].listType);
					sessionStorage.setItem('listName', prodholder[index].listName);
				} else {
					pushToDataLayer({
						"event": "eeListClick",
						"pageSubCategory": "",
						"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
						"filterChoice": getActiveSortingRule(),
						"dropDown": getRefinementsFromURL(),
						'products': [prodholder[0][index]]
					})
					sessionStorage.setItem('listType', prodholder[0][index].listType);
					sessionStorage.setItem('listName', prodholder[0][index].listName);
				}
			}
		})

		// PLP click in list name
		.on("click", "#search-result-items .gtmindex .name-link", function () {
			var index = $(this).parents(".gtmindex").index(".gtmindex");
			if (index >= 0) {

				if (productData.page > 0) {
					pushToDataLayer({
						"event": "eeListClick",
						"pageSubCategory": "",
						"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
						"filterChoice": getActiveSortingRule(),
						"dropDown": getRefinementsFromURL(),
						'products': [prodholder[index]]
					})
					sessionStorage.setItem('listType', prodholder[index].listType);
					sessionStorage.setItem('listName', prodholder[index].listName);
				} else {
					pushToDataLayer({
						"event": "eeListClick",
						"pageSubCategory": "",
						"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
						"filterChoice": getActiveSortingRule(),
						"dropDown": getRefinementsFromURL(),
						'products': [prodholder[0][index]]
					})
					sessionStorage.setItem('listType', prodholder[0][index].listType);
					sessionStorage.setItem('listName', prodholder[0][index].listName);
				}

			}
		})

		// PLP click in list view details
		.on("click", "#search-result-items .gtmindex .buy-button", function () {
			var index = $(this).parents(".gtmindex").index(".gtmindex");
			if (index >= 0) {

				if (productData.page > 0) {
					pushToDataLayer({
						"event": "eeListClick",
						"pageSubCategory": "",
						"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
						"filterChoice": getActiveSortingRule(),
						"dropDown": getRefinementsFromURL(),
						'products': [prodholder[index]]
					})
					sessionStorage.setItem('listType', prodholder[index].listType);
					sessionStorage.setItem('listName', prodholder[index].listName);
				} else {
					pushToDataLayer({
						"event": "eeListClick",
						"pageSubCategory": "",
						"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
						"filterChoice": getActiveSortingRule(),
						"dropDown": getRefinementsFromURL(),
						'products': [prodholder[0][index]]
					})
					sessionStorage.setItem('listType', prodholder[0][index].listType);
					sessionStorage.setItem('listName', prodholder[0][index].listName);
				}

			}
		})

		// Recommendation, bestseller eelistclick in homepage,pdp,cart
		.on("click", ".cross-sell .carousel-recommendations .product-tile-inner", function (e) {
			var index = $(this).parents("[class^='item-']").index();
			if (typeof forpageload.product[index] != undefined && forpageload.product[index] != null) {
				pushToDataLayer({
					"event": "eeListClick",
					"pageSubCategory": "",
					"pageCategory": getPageCategory(),
					"filterChoice": "",
					"dropDown": "",
					'products': [{
						"listType": forpageload.product[index].listType,
						"listName": forpageload.product[index].listName,
						"position": forpageload.product[index].position,
						"id": forpageload.product[index].id,
						"category": getProductCategory(),
						"price": forpageload.product[index].price,
						"name": forpageload.product[index].name,
						"brand": getProductBrand(),
						"quantity": forpageload.product[index].quantity,
						"size": forpageload.product[index].size,
						"subCategory": forpageload.product[index].subCategory,
						"subSubCategory": forpageload.product[index].subSubCategory,
						"productAutoReplen": forpageload.product[index].productAutoReplen,
						"productOutOfStock": forpageload.product[index].productOutOfStock,
						"productColor": forpageload.product[index].productColor,
						"productType": forpageload.product[index].productType,
						"productNumReviews": "",
						"productStarRating": ""
					}]
				})
				sessionStorage.setItem('listType', forpageload.product[index].listType);
				sessionStorage.setItem('listName', forpageload.product[index].listName);
			}

		})

		// Recently viewed eelistclick in homepage
		.on("click", ".cross-sell .carousel-recommendations .recommendation-item", function (e) {
			var index = $(this).index();
			if (typeof recentforpageload.product[index] != undefined && recentforpageload.product[index] != null) {
				pushToDataLayer({
					"event": "eeListClick",
					"pageSubCategory": "",
					"pageCategory": getPageCategory(),
					"filterChoice": "",
					"dropDown": "",
					'products': [{
						"listType": recentforpageload.product[index].listType,
						"listName": recentforpageload.product[index].listName,
						"position": recentforpageload.product[index].position,
						"id": recentforpageload.product[index].id,
						"category": getProductCategory(),
						"price": recentforpageload.product[index].price,
						"name": recentforpageload.product[index].name,
						"brand": getProductBrand(),
						"quantity": recentforpageload.product[index].quantity,
						"size": recentforpageload.product[index].size,
						"subCategory": recentforpageload.product[index].subCategory,
						"subSubCategory": recentforpageload.product[index].subSubCategory,
						"productAutoReplen": recentforpageload.product[index].productAutoReplen,
						"productOutOfStock": recentforpageload.product[index].productOutOfStock,
						"productColor": recentforpageload.product[index].productColor,
						"productType": recentforpageload.product[index].productType,
						"productNumReviews": "",
						"productStarRating": ""
					}]
				})
				sessionStorage.setItem('listType', recentforpageload.product[index].listType);
				sessionStorage.setItem('listName', recentforpageload.product[index].listName);
			}
		})

		// click on viewmore button
		.on("plpviewmore", function (e) {
			if (getPageCategory() == "Category Page") {
				if (prodholder && typeof productData.product != undefined) {
					if (productData.page > 1) {
						prodholder = prodholder.concat(productData.product);
					} else {
						prodholder = prodholder[0].concat(productData.product);
					}


					for (var i = 0; i < prodholder.length; i++) {
						prodholder[i].position = i + 1;
					}
					for (var a = 0; a < productData.product.length; a++) {
						var diff = productData.product.length - a;
						productData.product[a].position = (prodholder.length - diff) + 1;
					}
					pushToDataLayer({
						"event": "eeListView",
						"eeAction": "eeListView",
						"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
						"dropDown": "",
						"filterChoice": "",
						"currencyCode": window.User.currencyCode,
						"products": productData.product || new Array()
					});
				}
			}

		})

		// tracking change on image in 
		.on("afterChange", ".pdp-product-thumbnail-slider", function (e) {
			pushToDataLayer({
				"event": "productInteraction",
				"productCategory": getProductCategory(),
				"productSubCategory": getProductsubCategory(),
				"productName": getProductName(),
				"pageCategory": getPageCategory(),
				"productId": getProductID(),
				"interactionType": "Image Change"

			})
		})
		// click on next arrow recommendation carousel and best seller
		.on("click", ".pi .carousel-recommendations .slick-next", function (e) {
			if (typeof prodData != undefined && prodData != null) {
				var array = new Array();
				var listholder = new Array();
				var listchecker = false;
				var listctr = 0;
				$(".recommendation-item").each(function (index) {
					if ($(".recommendation-item").filter(".slick-active").length == 3) {
						if (index > 2 && $(this).hasClass("slick-active")) {
							array.push(index - 3);
						}
					} else {
						if (index > 2 && ($(this).hasClass("slick-active") || $(this).hasClass("slick-current"))) {
							listctr = 2;
							if (prodData.product.length > 3) {
								listchecker = true;
								listctr = 0;
							}
							array.push(index - 3);
						} else {
							if (listchecker && listctr < 2 && index > 2 && array.length <= 3) {
								if (array[array.length] != index - 3) {
									listctr += 1;
									array.push(index - 3);
								}
							} else {
								listchecker = false;
							}
						}


					}

				});
				for (var i = 0; i < prodData.product.length; i++) {
					for (var a = 0; a < array.length; a++) {
						if (i == array[a]) {
							listholder.push(prodData.product[i]);
						}
					}
				}
				pushToDataLayer({
					"currencyCode": window.User.currencyCode,
					"eeAction": "eeListView",
					"event": "eeListView",
					"pageCategory": getPageCategory(),
					"products": listholder
				});
			}
		})

		// click on prev arrow recommendation carousel and best seller
		.on("click", ".pi .carousel-recommendations .slick-prev", function (e) {

			if (typeof prodData != undefined && prodData != null) {
				var array = new Array();
				var listholder = new Array();
				var listchecker = false;
				var listctr = 0;
				$(".recommendation-item").each(function (index) {
					if ($(".recommendation-item").filter(".slick-active").length == 3) {
						if (index > 2 && $(this).hasClass("slick-active")) {
							array.push(index - 3);
						}
					} else {
						if (index > 2 && ($(this).hasClass("slick-active") || $(this).hasClass("slick-current"))) {
							listctr = 2;
							if (prodData.product.length > 3) {
								listchecker = true;
								listctr = 0;
							}
							array.push(index - 3);
						} else {
							if (listchecker && listctr < 2 && index > 2 && array.length <= 3) {
								if (array[array.length] != index - 3) {
									listctr += 1;
									array.push(index - 3);
								}
							} else {
								listchecker = false;
							}
						}


					}

				});
				for (var i = 0; i < prodData.product.length; i++) {
					for (var a = 0; a < array.length; a++) {
						if (i == array[a]) {
							listholder.push(prodData.product[i]);
						}
					}
				}
				pushToDataLayer({
					"currencyCode": window.User.currencyCode,
					"eeAction": "eeListView",
					"event": "eeListView",
					"pageCategory": getPageCategory(),
					"products": listholder
				});
			}
		})

		// click on next arrow recently viewed
		.on("click", ".cross-sell .carousel-recommendations .slick-next", function (e) {

			if (typeof prodData != undefined && prodData != null) {
				var array = new Array();
				var listholder = new Array();
				$(".recommendation-item").each(function (index) {
					if (index > 2 && $(this).hasClass("slick-active")) {
						array.push(index - 3);
					}
				});
				for (var i = 0; i < prodData.product.length; i++) {
					for (var a = 0; a < array.length; a++) {
						if (i == array[a]) {
							listholder.push(prodData.product[i]);
						}
					}
				}
				pushToDataLayer({
					"currencyCode": window.User.currencyCode,
					"eeAction": "eeListView",
					"event": "eeListView",
					"pageCategory": getPageCategory(),
					"products": listholder
				});
			}
		})

		// click on next arrow recently viewed
		.on("click", ".cross-sell .carousel-recommendations .slick-prev", function (e) {

			if (typeof prodData != undefined && prodData != null) {
				var array = new Array();
				var listholder = new Array();
				$(".recommendation-item").each(function (index) {
					if (index > 2 && $(this).hasClass("slick-active")) {
						array.push(index - 3);
					}
				});
				for (var i = 0; i < prodData.product.length; i++) {
					for (var a = 0; a < array.length; a++) {
						if (i == array[a]) {
							listholder.push(prodData.product[i]);
						}
					}
				}
				pushToDataLayer({
					"currencyCode": window.User.currencyCode,
					"eeAction": "eeListView",
					"event": "eeListView",
					"pageCategory": getPageCategory(),
					"products": listholder
				});
			}
		})

		// pdp fire when variation was change
		.on("gtvariationchange", function (e) {
			if (getPageCategory() == "Product Page") {
				pushToDataLayer({
					"eeAction": "eeProductDetail",
					"event": "eeProductDetail",
					"pageCategory": "Product Page",
					'products': [{
						"listType": sessionStorage.getItem('listType'),
						"listName": sessionStorage.getItem('listName'),
						"id": pdpdata.ID,
						"productVariantID": pdpdata.master ? pdpdata.defalutvariant : pdpdata.ID,
						"category": pdpdata.catid,
						"price": pdpdata.pricing.sale ? pdpdata.pricing.sale : pdpdata.pricing.minprice,
						"name": pdpdata.name,
						"brand": pdpdata.brand,
						"quantity": pdpdata.quantity,
						"size": pdpdata.size,
						"subCategory": pdpdata.subcategory,
						"subSubCategory": pdpdata.subsubcategory,
						"productAutoReplen": pdpdata.productautoreplenish,
						"productOutOfStock": pdpdata.productOutOfStock,
						"productColor": pdpdata.productColor,
						"productType": "Product",
						"collectionName": pdpdata.customBrand,
						"productNumReviews": pdpdata.productNumReviews,
						"productStarRating": pdpdata.productStarRating
					}]
				})
			}

		})

		// Variation change on product tile
		.on("gttilevariationchange", function (e) {
			pushToDataLayer({
				"event": "eeListClick",
				"pageCategory": getPageCategory(),
				'products': [{
					"listType": sessionStorage.getItem('listType'),
					"listName": sessionStorage.getItem('listName'),
					"id": tileVariantData.ID,
					"productVariantID": tileVariantData.master ? tileVariantData.defalutvariant : tileVariantData.ID,
					"category": tileVariantData.catid,
					"price": tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice,
					"name": tileVariantData.name,
					"brand": tileVariantData.brand,
					"quantity": tileVariantData.quantity,
					"size": tileVariantData.size,
					"subCategory": tileVariantData.subcategory,
					"subSubCategory": tileVariantData.subsubcategory,
					"productAutoReplen": tileVariantData.productautoreplenish,
					"productOutOfStock": tileVariantData.productOutOfStock,
					"productColor": tileVariantData.productColor,
					"productType": "Product",
					"collectionName": tileVariantData.customBrand,
					"productNumReviews": tileVariantData.productNumReviews,
					"productStarRating": tileVariantData.productStarRating
				}]
			})

		})

		//PLP filter change
		.on("selectmenuchange", ".top-filter select", function (event, ui) {
			pushToDataLayer({
				"event": "dropDownChoice",
				"dropDownType": event.target[0].label.trim(),
				"filterChoice": ui.item.label.trim(),
				"listType": "Product Category List",
				"listName": $(".breadcrumb").find(".breadcrumb-element:last").text().trim() + ">" + ui.item.label.trim()
			});
		})

		// 	Sort By in Makeup in PLP 		
		.on("selectmenuchange", ".sort-by select", function (event, ui) {
			pushToDataLayer({
				"event": "dropDownChoice",
				"dropDownType": "Sort By",
				"filterChoice": ui.item.label.trim(),
				"listType": "Product Category List",
				"listName": $(".breadcrumb").find(".breadcrumb-element:last").text().trim() + ">" + ui.item.label.trim()
			});
		})

		// 	related articles	
		.on('click', '.related-article-sec .related-article-content', function (e) {
			pushToDataLayer({
				"event": "relatedArticle",
				"page": $(this).children('a').text().trim(),
				"pageSubCategory": getPageSubcategory(),
				"pageCategory": $('.container .article-full-col h2').text().trim()
			});
		})

		// 	Article details product image click
		.on('click', '.article-content-section .product-tile .thumb-link', function (e) {
			var $productTile = $(this).parents(".product-tile");
			pushToDataLayer({
				"event": "shopTheArticle",
				"productName": $productTile.find('.product-name').text().trim(),
				"pageSubCategory": getPageSubcategory(),
				"pageCategory": $('.container .article-full-col h2').text().trim()
			});
		})

		// 	Article details product name click
		.on('click', '.article-content-section .product-tile .name-link', function (e) {
			var $productTile = $(this).parents(".product-tile");
			pushToDataLayer({
				"event": "shopTheArticle",
				"productName": $productTile.find('.product-name').text().trim(),
				"pageSubCategory": getPageSubcategory(),
				"pageCategory": $('.container .article-full-col h2').text().trim()
			});
		})

		// 	Article details product view details click	
		.on('click', '.article-content-section .product-tile .buy-button', function (e) {
			var $productTile = $(this).parents(".product-tile");
			pushToDataLayer({
				"event": "shopTheArticle",
				"productName": $productTile.find('.product-name').text().trim(),
				"pageSubCategory": getPageSubcategory(),
				"pageCategory": $('.container .article-full-col h2').text().trim()
			});
		})

		.on('click', '.search-result-content .product-tile-wrapper.product-grid', function (e) {
			if ($('.container .article-full-col h2').length < 1) {
				pushToDataLayer({
					"event": "shopTheArticle",
					"productName": $(this).find('.product-name').text().trim(),
					"pageSubCategory": getPageSubcategory(),
					"pageCategory": getPageCategory()
				});
			}
		})

		//Add to cart from various pages
		.on('click', '.product-tile-inner .add-to-cart', function (e) {
			var $gtmProductTile = $(this).parents(".product-tile").find('.gtm-product-tile');
			var tileVariantData = $gtmProductTile.data('value');
			pushToDataLayer({
				"currencyCode": window.Resources.CURRENCY,
				"event": "addToCart",
				"productOrderType": getProductOrederType(),
				"addToCartType": getPageCategory(),
				"pageCategory": getPageCategory(),
				'products': [{
					"id": tileVariantData.master ? tileVariantData.masterID : tileVariantData.ID,
					"productVariantID": tileVariantData.ID,
					"category": tileVariantData.catid,
					"price": tileVariantData.pricing ? tileVariantData.pricing.sale ? tileVariantData.pricing.sale : tileVariantData.pricing.minprice ? tileVariantData.pricing.minprice : null : null,
					"name": tileVariantData.name,
					"brand": tileVariantData.brand,
					"quantity": tileVariantData.quantity,
					"size": tileVariantData.size,
					"subCategory": tileVariantData.subcategory,
					"subSubCategory": tileVariantData.subsubcategory,
					"productAutoReplen": tileVariantData.productautoreplenish,
					"productOutOfStock": tileVariantData.productOutOfStock,
					"productColor": tileVariantData.productColor,
					"productType": "Product",
					"collectionName": tileVariantData.customBrand,
					"productNumReviews": tileVariantData.productNumReviews,
					"productStarRating": tileVariantData.productStarRating
				}]
			});
		})

		// Scroll on reviews in pdp
		$(window).on("scroll", function () {
			if ($(".bv-section-summary").length) {
				if (isScrolledIntoView(".bv-section-summary") && unbind < 1) {
					unbind = 1;
					pushToDataLayer({
						page: getpage(),
						event: "productReviewsView",
						productCategory: getProductCategory(),
						pageSubCategory: "Reviews",
						productName: getProductName(),
						pageCategory: "Product Page"
					});
				}
			}

			// for recommendation in pdp and cart, Best Seller and Recently Viewed in Homepage
			if ($(".pi .carousel-recommendations").length > 0 || $(".cross-sell .carousel-recommendations").length > 0) {
				$('.carousel-recommendations').each(function () {
					var result = isScrolledIntoView($(this));
					if (result[0]) {
						if (result[1] === 'recently-viewed cross-sell rv-section') {
							if (unbindreccarousel < 1) {
								unbindreccarousel = 1;
								pushToDataLayer({
									"currencyCode": window.User.currencyCode,
									"eeAction": "eeListView",
									"event": "eeListView",
									"pageCategory": getPageCategory(),
									"products": window.recentforpageload.product
								});
							}
						} else if (result[1].indexOf('pdp-social-media-section') == -1) {
							if (unbindcarousel < 1) {
								unbindcarousel = 1;
								pushToDataLayer({
									"currencyCode": window.User.currencyCode,
									"eeAction": "eeListView",
									"event": "eeListView",
									"pageCategory": getPageCategory(),
									"products": window.forpageload.product
								});
							}
						}
					}
				});
			}
		})
}

export default {
	init: function () {
		initializeGlobalEvents();
	},
	tagmanager: {
		click: function (data) {
			return trackConsultationEvent(data);
		},

		pageview: function (data) {
			return trackConsultationPageview(data);
		}
	},
	gtmInternalPromotion: {
		click: function (data) {
			return trackInternalPromotionEvent(data);
		},

		pageview: function (data) {
			return trackInternalPromotionPageView(data);
		}
	},
	filterPanelOpened: filterPanelOpened,
	filterPanelClosed: filterPanelClosed,
	minicartPanelOpened: minicartPanelOpened,
	minicartPanelClosed: minicartPanelClosed,
	cartModalClose: cartModalClose,
	cartModalOpen: cartModalOpen,
	minicartProductList : minicartProductList,
	addBonusProductMinicartDataLayer : addBonusProductMinicartDataLayer,
	quickViewClose : quickViewClose,
	quickViewShowDescription : quickViewShowDescription,
	quickviewCartAdd : quickviewCartAdd
}